import axios from 'axios'
import humps from 'humps'
import ApiError from './error'
import { getAnonymousId } from '../analytics'
import { getToken } from '~gatsby-theme-autonomy/redux/actions/auth'

export const BASE_API_URL =
  process.env.GATSBY_ACS_API_URL || 'http://localhost:3000'

const axiosClient = axios.create({
  baseURL: BASE_API_URL,
  headers: { 'Content-Type': 'application/json' },
  transformResponse: [
    ...axios.defaults.transformResponse,
    (data) => humps.camelizeKeys(data),
  ],
  transformRequest: [
    (data) => humps.decamelizeKeys(data),
    ...axios.defaults.transformRequest,
  ],
})

axiosClient.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const originalRequest = error.config

    if (
      originalRequest &&
      originalRequest?.headers?.['Authorization'] &&
      !originalRequest._retry &&
      error.response.status === 401
    ) {
      originalRequest._retry = true

      try {
        await axiosClient.store.dispatch(getToken())
        const state = axiosClient.store.getState()
        const authToken = state.auth.token
        if (authToken) {
          originalRequest.headers.Authorization = authToken
        }
      } catch (error) {}

      return axiosClient(originalRequest)
    }

    throw new ApiError(error)
  }
)

axiosClient.interceptors.request.use(
  (config) => {
    // if we are calling public APIs we don't have to add a token otherwise Solidus returns an error.
    if (!config.public) {
      // if there is not an Authorization header present on the request, add the order token. Some API requests will fail if both are used.
      if (!config.headers.Authorization) {
        const state = axiosClient.store.getState()
        const orderToken = state.cart.data.token
        if (orderToken) config.headers['X-Spree-Order-Token'] = orderToken
      }
    }

    const anonymousId = getAnonymousId()
    if (anonymousId) config.headers['ACS-Anonymous-Id'] = anonymousId

    config.headers['ACS-Store'] = process.env.GATSBY_ACS_STORE_NAME

    return config
  },
  async (error) => {
    throw new Error(error)
  }
)

export default axiosClient

export const axiosMiddleware = (store) => (next) => (action) => {
  axiosClient.store = store
  next(action)
}
